// @flow

import * as React from 'react';
import {useContext, useMemo, useState} from 'react';
import {useLocation} from 'docs/data';
import {activateNavigation} from './activateNavigation';

import type {Navigation} from './Navigation';

export type NavigationContextProps = {|
  navigation: Navigation,
  setNavigation: any,
|};

const NavigationContext = React.createContext<NavigationContextProps>({
  navigation: ({}: any),
  setNavigation: ({}: any),
});

type NavigationProviderProps = {|
  children: React.Node,
  navigation: Navigation,
|};

export const NavigationProvider = (props: NavigationProviderProps) => {
  const [navigation, setNavigation] = useState(props.navigation);
  const {location} = useLocation();

  const context = useMemo(
    () => ({
      navigation: activateNavigation(location, navigation),
      setNavigation,
    }),
    [location, navigation],
  );

  return (
    <NavigationContext.Provider value={context}>
      {props.children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  return useContext(NavigationContext);
};
